import React from 'react'
import { Link } from 'react-router-dom'
import { C, fOutfit, fBody, fMono, PublicNav, PublicFooter } from '../../../Shared/Brand'
import { Icon } from '../../../Shared/Icons'

const VALUES = [
  { icon: 'bot', title: 'Automation First', desc: 'Every strategy runs through the Arbitrade Bot — no manual desk, no emotional trading decisions.' },
  { icon: 'barChart', title: 'Transparent Reporting', desc: 'Live balances, profit history, and order hashes are visible in your dashboard at all times.' },
  { icon: 'shield', title: 'Risk Awareness', desc: 'We surface risk disclosures clearly and never present daily caps as guarantees.' },
]

export default function AboutUs() {
  return (
    <div style={{ background: C.white, color: C.tx, fontFamily: fBody, minHeight: '100vh' }}>
      <style>{`
        .xab-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 24px; }
      `}</style>
      <PublicNav active="Company" />

      <section style={{ padding: '130px 24px 60px', textAlign: 'center', background: C.dark, color: C.ltx, borderBottom: `1px solid ${C.dbdr}` }}>
        <div style={{ fontSize: '11px', fontFamily: fMono, letterSpacing: '0.14em', color: C.primary, textTransform: 'uppercase', marginBottom: '10px' }}>Company</div>
        <h1 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(32px,5vw,48px)', lineHeight: 1.1, margin: '0 0 14px' }}>About Xperia Capital</h1>
        <p style={{ fontSize: '16px', fontWeight: 500, color: C.ltx2, maxWidth: '600px', margin: '0 auto' }}>
          Xperia Capital Limited, based in Mauritius, builds automated crypto arbitrage infrastructure so traders can access cross-exchange opportunities without watching the market around the clock.
        </p>
      </section>

      <section style={{ padding: '64px 24px', maxWidth: '900px', margin: '0 auto' }}>
        <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(26px,3.5vw,34px)', lineHeight: 1.1, margin: '0 0 16px', color: C.tx }}>Our Mission</h2>
        <p style={{ fontSize: '16px', fontWeight: 500, color: C.tx2, lineHeight: 1.6, marginBottom: '14px' }}>
          Crypto markets move around the clock, but price gaps between exchanges are usually too fast and too small for a person to capture manually. Xperia Capital was built to close that gap — the Arbitrade Bot watches 50+ exchanges continuously and executes the moment a profitable spread appears.
        </p>
        <p style={{ fontSize: '16px', fontWeight: 500, color: C.tx2, lineHeight: 1.6 }}>
          We've since extended the same account to cover forex, precious metals, energies, and indices, so traders who want direct market access don't need to leave the platform to get it.
        </p>
      </section>

      <section style={{ padding: '64px 24px', borderTop: `1px solid ${C.bdr}`, background: C.light }}>
        <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(26px,3.5vw,34px)', lineHeight: 1.1, textAlign: 'center', margin: '0 0 40px', color: C.tx }}>What We Stand For</h2>
        <div className="xab-grid" style={{ maxWidth: '1000px', margin: '0 auto' }}>
          {VALUES.map(v => (
            <div key={v.title} style={{ textAlign: 'center' }}>
              <div style={{ color: C.primary, display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
                <Icon name={v.icon} size={36} strokeWidth={1.5} />
              </div>
              <div style={{ fontFamily: fOutfit, fontWeight: 600, fontSize: '18px', color: C.tx, marginBottom: '8px' }}>{v.title}</div>
              <p style={{ fontSize: '14px', color: C.tx2, lineHeight: 1.6, margin: 0 }}>{v.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section style={{ padding: '60px 24px 100px', textAlign: 'center' }}>
        <Link to="/company/regulation" style={{ display: 'inline-block', background: C.primary, color: C.dark, fontWeight: 700, fontSize: '13px', padding: '12px 24px', borderRadius: '999px', textDecoration: 'none', marginRight: '12px' }}>Regulation & Licences</Link>
        <Link to="/company/careers" style={{ display: 'inline-block', border: `1px solid ${C.bdr}`, color: C.tx2, fontWeight: 700, fontSize: '13px', padding: '12px 24px', borderRadius: '999px', textDecoration: 'none' }}>Careers</Link>
      </section>

      <PublicFooter />
    </div>
  )
}
